import { render, staticRenderFns } from "./ClassWarn.vue?vue&type=template&id=5141b27e&scoped=true"
import script from "./ClassWarn.vue?vue&type=script&lang=js"
export * from "./ClassWarn.vue?vue&type=script&lang=js"
import style0 from "./ClassWarn.vue?vue&type=style&index=0&id=5141b27e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141b27e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5141b27e')) {
      api.createRecord('5141b27e', component.options)
    } else {
      api.reload('5141b27e', component.options)
    }
    module.hot.accept("./ClassWarn.vue?vue&type=template&id=5141b27e&scoped=true", function () {
      api.rerender('5141b27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/ClassWarn.vue"
export default component.exports